module.exports = __webpack_public_path__ + "static/media/ai_icons_template_24.da0c0c34.ai";